import { render, staticRenderFns } from "./Imip.vue?vue&type=template&id=43c7cb9a&scoped=true"
import script from "./Imip.vue?vue&type=script&lang=js"
export * from "./Imip.vue?vue&type=script&lang=js"
import style0 from "./Imip.vue?vue&type=style&index=0&id=43c7cb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c7cb9a",
  null
  
)

export default component.exports